<div class="page-not-found" fxLayoutAlign="center center">
  <img src="../../../../assets/images/logos/error_404.svg" width="40%" />
</div>
